import { useContext, useEffect, useState } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import { useNavigate } from 'react-router-dom'
import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'
import { MeContext } from 'contexts/me'
import List, { ListItem } from 'components/List'
import { useSelectedAccountStore } from 'store'
import InfoCard from 'components/InfoCard'
import { formatCUIL } from 'utils'
import { getExternalAccountContacts } from 'api/bank'

const Recipient = () => {
  const navigate = useNavigate()
  const { entityData, selectedAccount } = useSelectedAccountStore()
  const { me } = useContext(MeContext)
  const [isFirstTime, setIsFirstTime] = useState<boolean | null>(null)

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_cuenta_destinatario' })

    getExternalAccountContacts().then((res) => {
      if (res.success) {
        const { result } = res.data

        const arrayCUIL = Array.from(Object.values(result), (val) =>
          Number(val[0].tax_identification_value)
        )
        const isFromContacts = arrayCUIL.includes(Number(selectedAccount.CUIL))
        const isOurs =
          selectedAccount.CUIL == me?.profile.tax_identification_value

        setIsFirstTime(!isOurs && !isFromContacts)
      }
    })
  }, [])

  const listItems = [
    {
      name: 'CBU/CVU',
      value: selectedAccount.CVU || selectedAccount.CBU
    },
    {
      name: 'CUIL',
      value: formatCUIL(selectedAccount.CUIL.toString())
    },
    {
      name: 'Banco',
      value: (
        <span className='flex gap-1'>
          {!!entityData.iconURL && (
            <>
              <img
                className='rounded-full h-5 w-5'
                src={entityData.iconURL}
                alt=''
              />{' '}
            </>
          )}
          {entityData.bankName}
        </span>
      )
    }
  ]

  return (
    <PageWrapper
      noTabBar
      title='Cuenta a transferir'
      viewSelected='/movimientos'
    >
      <section className='flex flex-col text-black items-center mx-auto sm:max-w-[25rem] h-[calc(100vh-12rem)]'>
        <p className='text-4xl text-center leading-tight'>
          {selectedAccount.accountHolder}
        </p>
        <p className='font-medium mb-4'>Titular de la cuenta</p>

        {selectedAccount.comesFromNewAccount && isFirstTime && (
          <InfoCard>
            <p>
              Te sugerimos verificar los datos del destinatario. Es la primera
              vez que le transferís a este contacto.
            </p>
          </InfoCard>
        )}

        <List>
          {listItems.map((i, idx) => (
            <ListItem key={idx} name={i.name} value={i.value} />
          ))}
        </List>

        <div className='space-y-4 mt-auto md:mt-6 w-full'>
          <PrimaryButton
            buttonText='Continuar'
            primaryButtonFunction={() =>
              navigate('/transferencias/nueva-transferencia', { replace: true })
            }
          />
          <PrimaryButton
            outlined
            buttonText='Cancelar'
            primaryButtonFunction={() => navigate('/transferencias')}
          />
        </div>
      </section>
    </PageWrapper>
  )
}

export default Recipient
